<script>
export default {
  name: 'TaskListItem',
  props: {
    task: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNewTaskDialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localShowTaskDialog: this.showNewTaskDialog,
    };
  },
};
</script>

<template>
  <tr>
    <td>{{ task.name }}</td>
    <td>{{ task.user ? task.user.username : null }}</td>
    <td>{{ task.priority }}</td>
    <td>{{ task.status }}</td>
    <td>{{ task.deadline }}</td>
    <td>
      <v-btn icon slot="activator" @click="localShowTaskDialog = true">
        <v-icon>add</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
